import { createTheme } from "@mui/material";
import { ThemeProvider } from "styled-components";
import Customertable from "../../components/ManageCustomer/Customertable";

const defaultTheme = createTheme();

const ManageCustomer = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <>
        <div className="ctpl-page-header">
          <div className="ctpl-title-col">
            <h1>Manage Users</h1>
            <p>Manage users, roles, module access and status.</p>
          </div>
        </div>

        <Customertable />
      </>
    </ThemeProvider>
  );
};

export default ManageCustomer;